<template>
<div id="ficheTnt" class="modal_container">
  <div class="modal_background">
    <div class="modal">
      <div class="modal_header">
        <div :class="pinStyle">TNT</div>
        <h3>Détails émetteur TNT</h3>
        <span class="icon_close" @click="closeModal()"></span>
      </div>
      <!-- ================= Modale incident en cours ================= -->
      <div class="modal_content" v-if="incidentEnCours">
        <div class="tnt_text tnt_text_out">Un incident a été détecté sur cet émetteur</div>
        <div class="resume">
          <div class="group">
            <label>Nom de l'émetteur : </label>
            <p>{{nomEmetteur}}</p>
          </div>
          <div class="group">
            <label>Date de début de l'incident :</label>
            <p>{{incident.dateDebut | printDate | handleMissingValue}}</p>
          </div>
          <div class="group">
            <label>Date de signalement :</label>
            <p>{{incident.dateSignalement | printDate | handleMissingValue}}</p>
          </div>
          <div class="group">
            <label>Multiplex :</label>
            <p>{{incident.multiplexes | printArray | handleMissingValue}}</p>
          </div>
          <div class="group">
            <label>Canaux :</label>
            <p>{{incident.canaux | printArray | handleMissingValue}}</p>
          </div>
          <div class="group">
            <label>Diffuseur :</label>
            <p>{{incident.diffuseurs | printArray | handleMissingValue}}</p>
          </div>
        </div>
        <div class="local_chanels">
          <h3>Description de l'incident :</h3>
          <p class="caracteristiques"> {{incident.syntheseDossier}} </p>
        </div>
      </div>
      <!-- ================= Modale emetteur actif ================= -->
      <div class="modal_content" v-else>
        <div class="resume">
          <div v-if="tnt && tnt.plusFort" class="tnt_text tnt_text_closest">Emetteur actif le plus proche</div>
          <div v-else class="tnt_text">Emetteur actif</div>
          <div class="group">
            <label>Nom de l'émetteur : </label>
            <p>{{nomEmetteur}}</p>
          </div>
          <div class="group tableContainer">
            <table>
              <thead>
                <tr>
                  <th> Mutiplexes diffusés </th>
                  <th> Canal par mux</th>
                  <th>Niveau de champ par mux *</th>
                  <th>Chaines locales</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in listeMultiplexes" :key="index">
                  <td> {{item.nom}} </td>
                  <td> {{item.canal}} </td>
                  <td> {{item.niveauChamp}} dBµV/m</td>
                  <td> {{item.chainesLocales}} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <p> * Cette valeur est exprimée en dBµV/m qui est l'unité de mesure du champ radioélectrique reçu par l'antenne. Elle se distingue de la tension présente dans les câbles exprimée en dBµV. La valeur est estimée au point centré sur la carte.</p>
      </div>
      <div class="modal_footer">
        <button @click="closeModal()" class="button dark">Fermer</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import moment from 'moment'
import _ from 'lodash'
export default {
  name: 'FicheTnt',
  components: {},
  data() {
    return {
      tnt: null,
      nomEmetteur: null,
      pinStyle: null,
      incidentEnCours: false,
      incident: null,
      listeMultiplexes: []
    }
  },
  created() {},
  destroyed() {},
  computed: {
    getDateDebut() {
      return moment(new Date(this.incident.dateDebut)).format('DD/MM/YYYY');
    },
    getDateSignalement() {
      return moment(new Date(this.incident.dateSignalement)).format('DD/MM/YYYY');
    },
  },
  filters: {
    printArray(value) {
      return value.toString().replace(/\[/g, "").replace(/]/g, "").replace(/(,(?=\S)|:)/g, ", ");
    },
    printDate(value) {
      return (value != null) ? moment(new Date(value)).format('DD/MM/YYYY') : null;
    },
    handleMissingValue(value) {
      return (value != null && value.length > 0) ? value : "Non renseigné";
    }
  },
  mounted() {},
  methods: {
    loadTnt(tnt, hasUnresolvedIncident) {
      this.tnt = JSON.parse(JSON.stringify(tnt.values_));
      this.nomEmetteur = this.tnt.nom;
      this.determinePinStyle(hasUnresolvedIncident);
      this.listeMultiplexes = [];
      this.incidentEnCours = false;
      if (hasUnresolvedIncident) {
        this.incidentEnCours = true;
        // Détermination de l'incident le plus récent
        var datePlusRecente = null;
        var incident = null;
        _.forEach(this.tnt.incidents, i => {
          var d = moment(new Date(i.dateDebut), 'DD/MM/YYYY[T]HH:mm:ss');
          if (datePlusRecente == null || d > datePlusRecente) {
            datePlusRecente = d;
            incident = i;
          }
        });
        incident.dateDebut = datePlusRecente;
        this.incident = incident;
      } else {
        // Récupération des multiplexes présents sur cet émetteur
        this.listeMultiplexes = _.sortBy(this.tnt.multiplex, [function(o) {
          return o.nom;
        }]);
      }
      this.openModal()
    },
    openModal() {
      var modal = document.getElementById('ficheTnt')
      var body = document.getElementsByTagName('body')[0]
      modal.classList.add('animation');
      body.classList.add('modal_active');
    },
    closeModal() {
      var modal = document.getElementById('ficheTnt');
      var body = document.getElementsByTagName('body')[0];
      modal.classList.remove('animation')
      body.classList.remove('modal_active')
    },
    /**
     * Style CSS de l'icône CSS de l'émetteur
     */
    determinePinStyle(hasUnresolvedIncident) {
      let style = "pin pin_tnt ";
      if (this.tnt.plusFort && !hasUnresolvedIncident) {
        this.pinStyle = style + "tnt_closest";
      } else if (hasUnresolvedIncident) {
        this.pinStyle = style + "tnt_out";
      } else {
        this.pinStyle = style;
      }
    }
  }
}
</script>

<style>
.modal_header {
  border-bottom: 0px solid rgb(220, 220, 220);
}

.caracteristiques {
  text-indent: 5%;
}

.group label {
  margin-top: 10px;
}

.chaine {
  border: 1px solid #81d1db;
  padding: 0;
  height: 50px;
  margin-bottom: 10px;
}

.nomChaine {
  background-color: #81d1db;
  color: white;
  width: 40px;
  font-weight: 600;
  line-height: 48px;
  text-align: center;
}

.listeChaines {
  display: flex;
  margin-left: 5px;
  align-items: center;
}

.listeChaines div {
  margin-right: 10px;
}

.listeChaines img {
  height: 20px;
  transform: translate(0, 25%);
}

.tableContainer {
  max-width: 100%;
  overflow: auto !important;
}

@media screen and (max-width: 600px) {
  .tableContainer {
    max-width: 400px;
  }
}

@media screen and (max-width: 500px) {
  .tableContainer {
    max-width: 350;
  }
}

@media screen and (max-width: 400px) {
  .tableContainer {
    max-width: 300px;
  }
}

</style>
